export default function setTitle (title = undefined) {
  const element = document.querySelector('title')

  if (element) {
    element.innerHTML = title ? `${title} | coral.help!` : 'coral.help!'
  }
}
